<script>
/* eslint-disable no-empty */
/* eslint-disable no-undef */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Swal from "sweetalert2";

import DatePicker from "vue2-datepicker";
import Switches from "vue-switches";
import Multiselect from "vue-multiselect";
import HotelDatePicker from "vue-hotel-datepicker";
import NumberInputSpinner from "vue-number-input-spinner";
import moment from "moment";
import { icons } from "../data-fontawesome";
import { urlMethods } from "@/state/helpers";

export default {
  page: {
    title: "Thu hồi POS",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    HotelDatePicker,
    DatePicker,
    Switches,
    Multiselect,
    NumberInputSpinner,
  },
  data() {
    return {
      title: "Thu hồi POS",
      icons: icons,
      totalRows: 0,
      currentPage: 1,
      orderfilterOn: [],
      orders: [],
      orderFilter: null,
      startDate: moment().subtract(7, 'days').format("DD/MM/YYYY"),
      endDate: moment().format("DD/MM/YYYY"),
      isLoading: false,
      dateRange: [new Date(moment().subtract(7, 'days').format("YYYY-MM-DD")), new Date()],
      statusSelected: [{ id: "all", name: "Tất cả trạng thái" }],
      storeSelected: [{ id: "all", name: "Tất cả siêu thị" }],
      posSelected: [{ id: "all", name: "Tất cả điểm bán lẻ" }],
      optionStatus: [
        { id: "all", name: "Tất cả trạng thái" },
        { id: "draft", name: "Mới" },
        { id: "recovery", name: "Nhập hàng thu hồi" },
        { id: "invoiced", name: "Đã xuất hoá đơn" },
        { id: "cancel", name: "Đã huỷ" },
      ],
      optionStore: [],
      optionPos: [],
      loadingArr: [],
      searchText: "",
      fields: [
        "id",
        {
          key: "name",
          label: "Mã thu hồi",
        },
        {
          key: "so_name",
          label: "Mã đơn hàng",
        },
        {
          key: "customer_name",
          label: "Khách hàng",
        },
        {
          key: "created_at",
          label: "Ngày thu hồi",
        },
        {
          key: "warehouse_name",
          label: "Kho nhập",
        },
        {
          key: "amount_total",
          label: "Tổng",
          formatter: (value) => {
            if (typeof value == "undefined" || value == null) return 0;
            return parseFloat(value).toLocaleString() + " ₫";
          },
        },
        {
          key: "status",
          label: "Trạng thái",
        },
      ],
    };
  },
  computed: {
    currentUser() {
      let user = localStorage.getItem("currentUser") || false;
      return user ? JSON.parse(user) : false;
    },
    windowWidth() {
      return window.innerWidth;
    },
  },
  methods: {
    ...urlMethods,
    changeTimeRange() {
      let that = this;
      that.startDate = moment(that.dateRange[0]).format("DD/MM/YYYY");
      that.endDate = moment(that.dateRange[1]).format("DD/MM/YYYY");
      that.currentPage = 1;
      that.getOrders();
    },
    searchOrder() {
      let that = this;
      that.currentPage = 1;
      that.getOrders();
    },
    changeStatus() {
      let that = this;
      that.currentPage = 1;
      that.getOrders();
    },
    changeStore() {
      let that = this;
      that.currentPage = 1;
      that.getOrders();
    },
    changePos() {
      this.getOrders();
    },
    changePage() {
      let that = this;
      that.getOrders();
    },
    getPosList() {
      let that = this;
      that.isLoading = true;
      setTimeout(async () => {
        try {
          let res = await that.getUrl("pos-list");
          that.optionPos = res.data;
        } catch (error) {
          let text = typeof error == "string" ? error : JSON.stringify(error);
          that.$store.dispatch("sale/setNoti", { text: text, type: "error" });
        }
        that.getOrders();
      }, 50);
    },
    async getOrderStep2() {
      let that = this;
      let statusFilter = [];
      let posFilter = [];
      let storeFilter = [];
      for (const stt of that.statusSelected) {
        if (stt.id == "all") statusFilter = ["all"];
        else if (!statusFilter.includes("all")) {
          statusFilter.push(stt.id);
        } else {
        }
      }
      for (const pos of that.posSelected) {
        if (pos.id == "all") posFilter = ["all"];
        else if (!posFilter.includes("all")) {
          posFilter.push(pos.id);
        } else {
        }
      }

      for (const stt of that.storeSelected) {
        if (stt.id == "all") storeFilter = ["all"];
        else if (!storeFilter.includes("all")) {
          storeFilter.push(stt.id);
        } else {
        }
      }

      let body = {
        start: that.startDate,
        end: that.endDate,
        s: that.searchText,
        status: statusFilter,
        page: that.currentPage,
        posID: that.currentUser.pos_id,
        pos: posFilter,
        store: storeFilter
      };
      try {
        let res = await that.postUrl({ url: "hbpos", data: body });
        that.orders = res.data;
        that.totalRows = res.total;
        that.isLoading = false;
      } catch (error) {
        that.orders = [];
        that.totalRows = 0;
        that.isLoading = false;
        let text = typeof error == "string" ? error : JSON.stringify(error);
        this.$store.dispatch("sale/setNoti", { text: text, type: "error" });
      }
    },
    removeLoading(_id = 0) {
      let that = this;
      that.loadingArr = that.loadingArr.filter(function(item) {
        return item != _id;
      });
    },
    loadingOrder(id = 0) {
      let that = this;
      return that.loadingArr.includes(id);
    },
    async syncOrder(id = 0) {
      let that = this;
      Swal.fire({
        title: "Bạn có chắc chắn?",
        showCancelButton: true,
        confirmButtonText: "Đồng bộ ngay",
        cancelButtonText: "Không. Bỏ qua",
      }).then(async (result) => {
        if (result.isConfirmed) {
          that.loadingArr.push(id);
          setTimeout(async () => {
            try {
              let res = await that.postUrl({
                url: "sync-order",
                data: { id: id, posID: that.currentUser.pos_id },
              });
              if (typeof res.error != "undefined" && res.error) {
                throw res.message;
              }
              that.removeLoading(id);
            } catch (error) {
              that.removeLoading(id);
              let text =
                typeof error == "string" ? error : JSON.stringify(error);
              this.$store.dispatch("sale/setNoti", {
                text: text,
                type: "error",
              });
            }
            that.getOrders();
          }, 100);
        } else if (result.isDenied) {
          that.removeLoading(id);
        }
      });
    },
    async cancelOrder(id = 0) {
      let that = this;
      Swal.fire({
        title: "Thao tác huỷ đơn không thể khôi phục. Bạn có chắc chắn?",
        showCancelButton: true,
        confirmButtonText: "Huỷ đơn",
        cancelButtonText: "Không. Bỏ qua",
      }).then(async (result) => {
        if (result.isConfirmed) {
          that.loadingArr.push(id);
          setTimeout(async () => {
            try {
              let res = await that.postUrl({
                url: "cancel-order",
                data: { id: id, posID: that.currentUser.pos_id },
              });
              if (typeof res.error != "undefined" && res.error) {
                throw res.message;
              }
              that.removeLoading(id);
            } catch (error) {
              that.removeLoading(id);
              let text =
                typeof error == "string" ? error : JSON.stringify(error);
              this.$store.dispatch("sale/setNoti", {
                text: text,
                type: "error",
              });
            }
            that.getOrders();
          }, 100);
        } else if (result.isDenied) {
          that.removeLoading(id);
        }
      });
    },
    async getOrders() {
      let that = this;
      that.isLoading = true;
      setTimeout(async () => {
        await that.getOrderStep2();
      }, 0);
    }, 
    async getStore() {
      let that = this;
      try {
        let res = await this.getUrl("hbpos/list-store");
        if (res.data) {
          res.data.map(function(value, key) {
            that.optionStore.push({ id: value.id, name: value.name });
          });
        }
        that.isLoading = false;
      } catch (error) {
        that.optionStore = [];
        that.isLoading = false;

        let text = typeof error == "string" ? error : JSON.stringify(error);
        this.$store.dispatch("sale/setNoti", { text: text, type: "error" });
      }
    },
  },
  mounted() {
    if (this.currentUser.role == 1) {
      this.getPosList();
    } else {
      this.getOrders();
    }
    this.getStore();
  },
};
</script>

<template>
  <Layout>
    <div class="page-header mb-2">
      <div class="page-title">
        <h4 class="mb-0 font-size-18">Đơn thu hồi POS</h4>
      </div>
      <router-link to="/hbpos/add">
        <b-button variant="primary">Tạo phiếu</b-button>
      </router-link>
    </div>
    <div class="card">
      <div class="card-body pb-0">
        <div class="filter-box">
          <div class="filter-item">
            <div class="search-box me-2 mb-0 d-inline-block">
              <div class="position-relative">
                <input
                  type="text"
                  class="form-control"
                  v-model="searchText"
                  v-on:keyup.enter="searchOrder"
                  placeholder="Tìm theo mã HB, POS, SĐT"
                />
                <i class="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div class="filter-item filter-daterange">
            <date-picker
              v-model="dateRange"
              range
              append-to-body
              lang="vn"
              confirm
              @change="changeTimeRange"
            ></date-picker>
          </div>

          <div class="filter-item" style="min-width: 170px;">
            <multiselect
              :show-labels="false"
              v-model="statusSelected"
              label="name"
              track-by="id"
              placeholder="Trạng thái"
              @change="changeStatus"
              @input="changeStatus"
              @select="changeStatus"
              :options="optionStatus"
              :multiple="true"
            ></multiselect>
          </div>
          <div
            class="filter-item"
            style="min-width: 170px;"
            v-if="optionPos.length > 1"
          >
            <multiselect
              :show-labels="false"
              v-model="posSelected"
              label="name"
              track-by="id"
              placeholder="Trạng thái"
              @change="changePos"
              @input="changePos"
              @select="changePos"
              :options="optionPos"
              :multiple="true"
            ></multiselect>
          </div>

          <div class="filter-item" style="min-width: 250px;">
            <multiselect
              :show-labels="false"
              v-model="storeSelected"
              label="name"
              track-by="id"
              placeholder="Siêu Thị"
              @change="changeStore"
              @input="changeStore"
              @select="changeStore"
              :options="optionStore"
              :multiple="true"
            ></multiselect>
          </div>

          <div
            class="filter-item"
            style="display:flex;align-items:center;justify-content:center;flex-direction:column;"
          >
            <i
              :class="!isLoading ? ' hiden' : ''"
              style="line-height: 1"
              class="fas fa-spinner fa-spin font-size-18"
            ></i>
          </div>
          <div class="filter-item filter-end"></div>
        </div>
        <div
          class="table-responsive"
          style="padding: 0px 0px 15px"
          v-if="orders.length > 0"
        >
          <b-table
            id="my-table"
            class="p-0 m-0 table-striped table-bordered"
            striped
            hover
            :items="orders"
            :fields="fields"
          >
            <template v-slot:cell(name)="data">
              <router-link :to="`/hbpos/${data.item.id}`">{{
                data.item.name
              }}</router-link>
            </template>
            <template v-slot:cell(status)="data">
              <span
                :class="'badge font-size-12 bg-' + data.item.status_class"
                >{{ data.item.status_name }}</span
              >
            </template>
          </b-table>
        </div>
        <div class="row" style="padding-bottom: 15px;" v-if="totalRows > 30">
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <b-pagination
                  aria-controls="my-table"
                  @change="changePage"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="30"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
